<template>
  <v-slide-y-reverse-transition>
    <div v-if="uploads.length" class="floating-upload-wrapper">
      <v-card class="floating-card px-3 pb-3" elevation="8">
        <div
          class="card-header mb-2 text-body-2 font-weight-bold d-flex align-center"
        >
          Fazendo a importação de
          {{ uploads.length }} vídeo(s)

          <v-spacer />

          <v-btn small icon @click="closeMenu()">
            <v-icon color="black" small>mdi-window-minimize</v-icon>
          </v-btn>
        </div>

        <div v-for="upload in uploads" :key="upload.id" class="upload-item">
          <div class="upload-header">
            <v-tooltip color="black" top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="upload-label">
                  <span v-if="upload.status === 'done'">Vídeo Importado</span>

                  <span v-else-if="upload.status === 'error'">
                    Falha ao importar, tente novamente
                  </span>

                  <span v-else-if="upload.status === 'canceled'">
                    Cancelado
                  </span>

                  <span v-else>
                    {{ upload.label }}
                  </span>
                </span>
              </template>

              <span>
                {{ upload.fileNames.join(",") }}
              </span>
            </v-tooltip>

            <span v-if="upload.status === 'uploading'">
              <span class="upload-percent mr-1"> {{ upload.progress }}% </span>

              <v-icon color="red" small @click="cancelUpload(upload.id)"
                >mdi-close-thick</v-icon
              >
            </span>

            <v-icon v-else-if="upload.status === 'done'" color="green" small>
              mdi-checkbox-marked-circle-outline
            </v-icon>

            <v-icon v-else-if="upload.status === 'error'" color="red" small>
              mdi-alert-circle-outline
            </v-icon>
          </div>

          <v-progress-linear
            :value="upload.progress"
            height="6"
            rounded
            striped
            :color="fetchProgressColor(upload)"
          />
        </div>
      </v-card>
    </div>
  </v-slide-y-reverse-transition>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "FloatingUpload",

  computed: {
    ...mapState({
      uploads: (state) => state.upload.queue,
    }),
  },

  methods: {
    ...mapActions("upload", ["clearUploads", "cancelUpload"]),

    closeMenu() {
      this.clearUploads();
    },

    fetchProgressColor(upload) {
      if (upload.status === "done") return "green accent-4";
      if (upload.status === "error") return "red accent-3";
      if (upload.status === "canceled") return "grey";

      return "primary";
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
